module.exports = __webpack_public_path__ + "img/UTFHNH-4.d60587cc.jpg";